export default "__VITE_ASSET__B044o863__"